export default __webpack_public_path__ + "static/media/_DSC0890.92e97924.JPG";